// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"527":"45fe88c6","966":"7945b887"}[chunkId] + ".css";
};